import { IconDefinition } from "./types";

const messageQuestion: IconDefinition = {
  iconName: "message-question",
  width: 512,
  height: 512,
  svgPathData:
    "M200.7 500.4c-12.6 7.5-36.8 22.1-72.7 43.6l0-96-128 0 0-416 512 0 0 416-224 0-87.3 52.4zM176 459.2c22.9-13.7 67.8-40.7 87.3-52.4l11.4-6.8 189.3 0 0-320-416 0 0 320 128 0 0 59.2zm80-294c-17.7 0-32 14.3-32 32l-42.4 0c0-41.1 33.3-74.4 74.4-74.4s74.4 33.3 74.4 74.4c0 33.3-19.8 52.7-37.4 62.5-5.5 3.1-11 5.4-15.8 7.1l0 18.3-42.4 0 0-53.5c2.3-.3 4.6-.6 6.9-.9 10.5-1.3 21.1-2.7 30.5-8 9-5.1 15.8-12.4 15.8-25.6 0-17.7-14.3-32-32-32zM232 312l48 0 0 48-48 0 0-48z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "message-question",
  unicode: 0xe1e3,
};

export { messageQuestion };
